<template>
  <div class="artical-detial">
    <div class="artical-title">
      <h2 class="ta_c">快来打卡！</h2>
      <h2 class="ta_c">绿瘦美学馆正式亮相上海绿瘦酒店！绿瘦训练营</h2>
    </div>
    <div class="artical-body">
      <p>盛夏7月，生机盎然，在众多朋友的关心和期盼下，火遍全国的绿瘦美学馆正式在上海绿瘦酒店营业啦！</p>
      <p>这一次，绿瘦美学馆来到上海市闵行区，它临近上海虹桥机场、虹桥站，交通十分方便。入住绿瘦酒店，大家不仅可以享受到星级的酒店服务，还能体验到星级的美容院服务！</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_a.png" alt="">
      <p class="img-desc ta_c">（上海绿瘦酒店外景）</p>

      <h3 class="ta_c">舒心的美学空间</h3>
      <p>绿瘦美学馆携手国际4A团队，精心打造一个时尚而舒适的美学空间。店面以绿色为主色调，传递了健康、清新、活力的品牌个性。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_b.png" alt="">
      <p class="img-desc ta_c">（上海绿瘦酒店外景）</p>
      <p>从灯饰、布艺到盆景，每一个细节都透露着用心，自然的配色与流畅的线条设计巧妙融合，使整个空间变得柔和，能让每一位客户放松身心，在这里发现美、感受美！</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_c.png" alt="">
      <p class="img-desc ta_c">（产品展示区）</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_e.png" alt="">
      <p class="img-desc ta_c">（文化长廊）</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_f.png" alt="">
      <p class="img-desc ta_c">（VIP体验间）</p>
      
      <h3 class="ta_c">专业的护理服务</h3>
      <p>秉承了绿瘦十余年的专业体重管理经验和用户大数据，在深入分析中国女性对美的全方位需求后，绿瘦美学馆倾情打造以“形体、美颜、健康”管理为一体的360美丽管理系统，帮助广大女性实现从纤瘦到美丽、健康的升级！</p>
      <p style="text-indent:0rem;">一、360形体管理</p>
      <p>从FTO基因开始追溯肥胖根源，量身定制个性化瘦身方案。高科技仪器+天然精油制品+纤体手法+营养调衡，有效击碎体内多余脂肪，以通、排、紧、塑开启形体管理，让你畅享健康完美S曲线。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_g.png" alt="">
      <p class="img-desc ta_c">（高科技减肥仪器）</p>
      <p style="text-indent:0rem;">二、360美颜管理</p>
      <p> 针对不同年龄、不同人群的肌肤问题，绿瘦美学馆通过智能皮肤检测，利用射频、电波等美容科技，注入天然植物的修复力量，重塑肌肤屏障，从肤色、肤质，再到轮廓焕变，让女性朋友重拾青春靓丽容颜。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_h.png" alt="">
      <p class="img-desc ta_c">（面部护理）</p>
      <p style="text-indent:0rem;">二、360美颜管理</p>
      <p> 针对不同年龄、不同人群的肌肤问题，绿瘦美学馆通过智能皮肤检测，利用射频、电波等美容科技，注入天然植物的修复力量，重塑肌肤屏障，从肤色、肤质，再到轮廓焕变，让女性朋友重拾青春靓丽容颜。</p>
      <img src="http://www.lvshouhotel.com/lvshouhotel/img_news_one_i.png" alt="">
      <p class="img-desc ta_c">（七轮闻香精油）</p>
      <p> 夏日好时光，出游正当时。如果你恰好到上海旅游，不妨入住绿瘦酒店，绿瘦美学馆为大家准备了特惠项目代金券还有众多惊喜好礼，就等你来哦！</p>

    </div>
  </div>
</template>
<script>

export default {

  name:'articalOne',
  data(){
    return{
      
    }
  },
  methods:{
    
  }
}
</script>
<style lang="less" scoped>


</style>


